import { Fragment } from "react";
import { DateRangePresetOption } from "./dateRangePresetOption";

const presetGroups = [
    [
        { key: "currentDay", label: "Today" },
    ],
    [
        { key: "currentMonth", label: "This month" },
        { key: "currentQuarter", label: "This quarter" },
        { key: "currentYear", label: "This year" },
    ],
    [
        { key: "lastMonth", label: "Last month" },
        { key: "lastQuarter", label: "Last quarter" },
        { key: "lastYear", label: "Last year" },
    ],
    [
        { key: "monthToDate", label: "Month to date" },
        { key: "quarterToDate", label: "Quarter to date" },
        { key: "yearToDate", label: "Year to date" },
    ],
]

export const DateMegaControl = ({ setDateRange, onCustomRangeSelect, showClearOption, onClear, isPlacedRight, fromDate, toDate }) => {

    return (
        <div className="btn-group date-mega-control">
            <button className="btn dropdown-toggle m-0" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>
            <div className={`dropdown-menu ${isPlacedRight && "dropdown-menu-right"}`}>

                {presetGroups.map(group => (
                    <Fragment key={group[0].key}>
                        {group.map(preset => (
                            <DateRangePresetOption
                                fromDate={fromDate}
                                toDate={toDate}
                                rangeType={preset.key}
                                label={preset.label}
                                setDateRange={(firstDate, lastDate) => setDateRange(firstDate, lastDate, preset.label)}
                                key={preset.key}
                            />
                        ))}
                        <div className="dropdown-divider"></div>
                    </Fragment>
                ))}

                <button className="dropdown-item" onClick={ () => onCustomRangeSelect() }><span><i className="far fa-calendar-alt"></i>Custom date range</span></button>

                { showClearOption && <button onClick={ () => onClear() } className="dropdown-item"><span><i className="fas fa-times"></i> Clear</span></button> }
            </div>
        </div>
    )
}